<template>
    <div>
        <ViewTargets  v-if="!!item" @success="alertSuccess"></ViewTargets>

        <TargetsTable
            title="Users"
            @addTargets="showTargetsModal"
            ref="table"
        >
       
    </TargetsTable>
        
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import TargetsTable from './TargetsTable'
import ViewTargets from './ViewTargets'
// import CreateVehicleForm from './CreateVehicleForm'

export default {
    name: 'Targets',
    mixins: [popupMixins, permissionsMixins],
    components: {
        TargetsTable,
        ViewTargets,
        
    },
    data: () => {
        return {
            item: null,
          
        }
    },
    async mounted(){
        // await this.$store.dispatch('targets/fetchUsers');
    },
    methods: {
        alertSuccess(action) {
            console.log("asdasda",action)
            console.log(this.item)
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${name} has been succcessfully ${action.toLowerCase()}`
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.$refs.table.doSearch()
        },
        showTargetsModal() {
            this.$refs.createDocumentType.showModal()
        },
        // created() {
        //     this.doToast('Created!', 'Vehicle Created', 'success')
        //     this.$refs.table.doSearch()
        //     this.$refs.createVehicle.hideModal()
        // },
        handleError(error) {
            this.doToast(this.$translate('error'), error.message, 'danger')
        },
      
    },
}
</script>
<style></style>
